import { Drawer, Box, Typography, TableContainer, Table, TableBody, TableRow, TableCell, TableHead, Chip } from '@material-ui/core';
import React from 'react';
import { IResumo } from '../../types/Resumo';

interface Props {
    open: boolean;
    consolidado?: boolean;
    error?: string;
    onClose: () => void;
    data: IResumo;
}

function ResumoDrawer(props: Props) {
    return (
        <Drawer anchor="right" open={props.open} onClose={props.onClose}>
            <Box p={2}>
                <Box mb={2}>
                    <Typography variant="h6" component="div" align="center">
                        RESUMO
                    </Typography>
                </Box>
                {props.error ?
                    <Chip label={props.error} />
                    :
                    <React.Fragment>
                        <Box mb={2}>
                            <TableContainer>
                                <Table stickyHeader>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell variant="head">DESCONTO PARA NEGOCIAÇÃO</TableCell>
                                            <TableCell align="right">{props.data.desconto_negociacao}</TableCell>
                                        </TableRow>
                                        {!props.consolidado &&
                                            <TableRow>
                                                <TableCell variant="head">PREÇO UNITÁRIO LÍQUIDO SEM IMPOSTOS</TableCell>
                                                <TableCell align="right">{props.data.preco_un_liq_sem_impostos}</TableCell>
                                            </TableRow>
                                        }
                                        <TableRow>
                                            <TableCell variant="head">PREÇO TOTAL SEM IMPOSTOS</TableCell>
                                            <TableCell align="right">{props.data.preco_total_sem_impostos}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                        <Box mb={2}>
                            <TableContainer>
                                <Table stickyHeader>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell variant="head">ICMS</TableCell>
                                            <TableCell variant="head">{props.data.icms ? props.data.icms.porcentagem : ""}</TableCell>
                                            <TableCell variant="head">{props.data.moeda}</TableCell>
                                            <TableCell align="right">{props.data.icms ? props.data.icms.total : ""}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell variant="head">PIS/COFINS</TableCell>
                                            <TableCell variant="head">{props.data.pis_cofins ? props.data.pis_cofins.porcentagem : ""}</TableCell>
                                            <TableCell variant="head">{props.data.moeda}</TableCell>
                                            <TableCell align="right">{props.data.pis_cofins ? props.data.pis_cofins.total : ""}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell variant="head">IPI</TableCell>
                                            <TableCell variant="head">{props.data.ipi ? props.data.ipi.porcentagem : ""}</TableCell>
                                            <TableCell variant="head">{props.data.moeda}</TableCell>
                                            <TableCell align="right">{props.data.ipi ? props.data.ipi.total : ""}</TableCell>
                                        </TableRow>
                                        {!props.consolidado &&
                                            <React.Fragment>
                                                <TableRow>
                                                    <TableCell variant="head" colSpan={2}>PREÇO UNIT. PETRONECT</TableCell>
                                                    <TableCell variant="head">{props.data.moeda}</TableCell>
                                                    <TableCell align="right">{props.data.preco_unit_petronect}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell variant="head" colSpan={2}>PREÇO UNIT. COM IMPOSTOS SEM IPI</TableCell>
                                                    <TableCell variant="head">{props.data.moeda}</TableCell>
                                                    <TableCell align="right">{props.data.preco_unit_com_impostos_sem_ipi}</TableCell>
                                                </TableRow>
                                            </React.Fragment>
                                        }
                                        <TableRow>
                                            <TableCell variant="head" colSpan={2}>PREÇO TOTAL COM IMPOSTOS SEM IPI</TableCell>
                                            <TableCell variant="head">{props.data.moeda}</TableCell>
                                            <TableCell align="right">{props.data.preco_total_com_impostos_sem_ipi}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell variant="head" colSpan={2}>PREÇO TOTAL COM IMPOSTOS COM IPI</TableCell>
                                            <TableCell variant="head">{props.data.moeda}</TableCell>
                                            <TableCell align="right">{props.data.preco_total_com_impostos_com_ipi}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                        <TableContainer>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>VALORES</TableCell>
                                        <TableCell>KSB</TableCell>
                                        <TableCell>BUY OUT</TableCell>
                                        <TableCell>TOTAL</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>RECEITA</TableCell>
                                        <TableCell>{props.data.receita ? props.data.receita.KSB : ""}</TableCell>
                                        <TableCell>{props.data.receita ? props.data.receita.buyout : ""}</TableCell>
                                        <TableCell>{props.data.receita ? props.data.receita.total : ""}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>ENCARGOS</TableCell>
                                        <TableCell>{props.data.encargos ? props.data.encargos.KSB : ""}</TableCell>
                                        <TableCell>{props.data.encargos ? props.data.encargos.buyout : ""}</TableCell>
                                        <TableCell>{props.data.encargos ? props.data.encargos.total : ""}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>CUSTO DOS MATERIAIS</TableCell>
                                        <TableCell>{props.data.custos_materiais ? props.data.custos_materiais.KSB : ""}</TableCell>
                                        <TableCell>{props.data.custos_materiais ? props.data.custos_materiais.buyout : ""}</TableCell>
                                        <TableCell>{props.data.custos_materiais ? props.data.custos_materiais.total : ""}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>GROSS INCOME</TableCell>
                                        <TableCell>{props.data.gross_income ? props.data.gross_income.KSB : ""}</TableCell>
                                        <TableCell>{props.data.gross_income ? props.data.gross_income.buyout : ""}</TableCell>
                                        <TableCell>{props.data.gross_income ? props.data.gross_income.total : ""}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell variant="head">GI</TableCell>
                                        <TableCell variant="head">{props.data.gi ? props.data.gi.KSB : ""}</TableCell>
                                        <TableCell variant="head">{props.data.gi ? props.data.gi.buyout : ""}</TableCell>
                                        <TableCell variant="head">{props.data.gi ? props.data.gi.total : ""}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>CUSTO VARIÁVEL</TableCell>
                                        <TableCell>{props.data.custo_variavel ? props.data.custo_variavel.KSB : ""}</TableCell>
                                        <TableCell>{props.data.custo_variavel ? props.data.custo_variavel.buyout : ""}</TableCell>
                                        <TableCell>{props.data.custo_variavel ? props.data.custo_variavel.total : ""}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>MARGEM I</TableCell>
                                        <TableCell>{props.data.margem_1 ? props.data.margem_1.KSB : ""}</TableCell>
                                        <TableCell>{props.data.margem_1 ? props.data.margem_1.buyout : ""}</TableCell>
                                        <TableCell>{props.data.margem_1 ? props.data.margem_1.total : ""}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell variant="head">MC I</TableCell>
                                        <TableCell variant="head">{props.data.mc_1 ? props.data.mc_1.KSB : ""}</TableCell>
                                        <TableCell variant="head">{props.data.mc_1 ? props.data.mc_1.buyout : ""}</TableCell>
                                        <TableCell variant="head">{props.data.mc_1 ? props.data.mc_1.total : ""}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>CUSTO FIXO</TableCell>
                                        <TableCell>{props.data.custo_total ? props.data.custo_total.KSB : ""}</TableCell>
                                        <TableCell>{props.data.custo_total ? props.data.custo_total.buyout : ""}</TableCell>
                                        <TableCell>{props.data.custo_total ? props.data.custo_total.total : ""}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>MARGEM II</TableCell>
                                        <TableCell>{props.data.margem_2 ? props.data.margem_2.KSB : ""}</TableCell>
                                        <TableCell>{props.data.margem_2 ? props.data.margem_2.buyout : ""}</TableCell>
                                        <TableCell>{props.data.margem_2 ? props.data.margem_2.total : ""}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell variant="head">MC II</TableCell>
                                        <TableCell variant="head">{props.data.mc_2 ? props.data.mc_2.KSB : ""}</TableCell>
                                        <TableCell variant="head">{props.data.mc_2 ? props.data.mc_2.buyout : ""}</TableCell>
                                        <TableCell variant="head">{props.data.mc_2 ? props.data.mc_2.total : ""}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </React.Fragment>
                }
            </Box>
        </Drawer>
    );
}

export default ResumoDrawer;